const featureItems = [
  {
    icon: 'ri-flashlight-line',
    title: '24小时滚动追踪',
    desc: '编辑团队全天候值守，重大事件15分钟内上线报道，让你永远走在吃瓜第一线。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '多源交叉验证',
    desc: '每条爆料需经至少2个独立信源确认，标注可信度等级，拒绝虚假信息传播。',
  },
  {
    icon: 'ri-global-line',
    title: '全网覆盖监测',
    desc: '覆盖娱乐圈、直播圈、短视频、电竞等全领域，一个入口追踪所有热点动向。',
  },
  {
    icon: 'ri-file-search-line',
    title: '深度扒皮档案',
    desc: '每起事件建立完整时间线与证据链档案，支持按人名、关键词快速检索回顾。',
  },
  {
    icon: 'ri-lock-2-line',
    title: '隐私严格保护',
    desc: '投稿人信息加密存储，匿名爆料通道保障安全，绝不向任何第三方透露信源。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-4xl font-heading font-black text-foreground-50 text-center mb-14">
          平台优势：为什么选择五一吃瓜
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {featureItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-300 rounded-2xl p-8 text-center hover:outline hover:outline-1 hover:outline-accent-500 transition-all duration-300 hover:-translate-y-1 cursor-default group"
            >
              <div className="w-16 h-16 mx-auto rounded-2xl bg-background-200 flex items-center justify-center mb-5 group-hover:bg-accent-500/10 transition-colors duration-300">
                <i className={`${item.icon} text-2xl text-foreground-50`}></i>
              </div>
              <h3 className="text-base font-bold text-foreground-50 font-heading mb-2.5">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-400 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}